<style lang="stylus">
    .OCRModal-mask {
      //modal-mask()

      .OCRModal-modal {
        //width: 740px;
        //height: 560px
      }

      .title-text {
        box-sizing:border-box;
        display: flex;
        align-items: center;
        width: 100%
        .title-logo {
          width: 24px;
          height: 24px;
        }

        .title-yiwen {
          color: var(--svg-color-gray-42-secondary);
          margin-left: 4px;
          cursor: pointer;
          width: 14px;
          height: 14px;
          &:focus {
            outline: none;
          }
          &:hover {
            color: var(--bg-color-ocrmodal-title-tips-hover);
          }
        }

        .title-content {
          margin-left: 8px
        }
        .points{
          font-weight: 500;
          height: 32px;
          background: var(--bg-color-ocrmodal-points);
          border-radius: 32px;
          margin-right: 80px;
          margin-left: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          color: var(--themeColor);
          font-size: 12px;
          padding:0 12px;
          &:hover{
            background: #017fff1a;
          }
          svg{
            width: 24px;
            height: 24px;
            margin-top -2px;
          }
          a {
            color var(--themeColor)
            height: 24px;
            line-height 24px;
          }
        }

      }
      .empty{
        width: 88px
        height: 66px
      }
      .OCRModal-container {
        display: flex;

        .OCRModal-container-item {
          background-color: var(--bg-color-OCRModal-container-item);
          border-radius: 6px;

          &.left {
            width: 400px;
            height: 420px;
            position: relative;

            .ivu-upload {
              background: transparent;
              margin: 24px;
              margin-top: 45px;

              .ivu-upload-drag {
                padding: 40px 20px;
                background: var(--bg-color-OCRModal-container-ivu-upload-drag);
                cursor: initial;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px dashed var(--border-color-ocrmodal-ivu-upload-drag);
                border-radius: 16px;
                margin: 0;

                &:hover {
                  border-color: var(--border-color-ocrmodal-ivu-upload-drag-hover)
                  background-color: var(--bg-color-OCRModal-container-ivu-upload-drag-hover);
                  color: #222;
                }

              }
            }

          }

          &.right {
            margin-left: 16px;
            height: 420px;
            width: 273px;

            .container-part-1 {
              height: 100%;
              justify-content: center;
              align-items: center;
              display: flex;
              text-align: center;

              > div {
                width: 228px;
              }
            }
          }
          .ORC-loading-logobox {
            position relative
            margin 0 auto
            width: 40px;
            height: 44px;
            .ORC-loading-logo {
                margin-left: -2px;
                width: 40px;
                height: 44px;
                color var(--themeColor)
            }
            .ocr-logo-animation {
                position absolute
                margin-left: 0;
                left 0
                top 0
                height: 8px;
                animation ocrmove 1.5s linear alternate infinite
            }
            @keyframes ocrmove {
                0 {
                    top: 0
                }
                100% {
                    top: calc(100% - 10px)
                }
            }
          }

          .textarea-container {
            position: relative;
            height: 100%;

            .text-area {
              height: 100%;
              textarea {
                color: var(--text-color-primary);
              }

              .ivu-input {
                height: inherit;
                border: none;
                background-color: transparent;
                resize: none;
                padding: 30px 24px;

                &:focus {
                  border: transparent;
                  box-shadow: none;
                  outline: 0;
                }
              }
            }

            .copy-btn {
              position: absolute;
              right: 10px;
              top: 10px;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: 28px;
              height: 28px;
              background: #FFFFFF;
              box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
              border-radius: 24px;
              cursor: pointer;
              transition: color 0.2s;
              float: left;

              &:hover {
                background-color: var(--themeColor);
                color: white;
              }

              svg {
                height: 16px;
                width: 16px
              }
            }
          }

        }
      }

      .dialog-btnbox-normal {
        margin-top: 24px

        .dialog-disable {
          pointer-events: auto !important;
        }
      }

      .dialog-title {
        height: 50px

        .title-text {
          line-height: 60px
        }

        .title-close {
          top: 16px;
          right: 24px;
        }

      }

      .upload-container {
        text-align: center;

        .upload-container-img {
          margin: 0 auto;
        }

        .upload-container-text {
          margin-top: 8px;
          font-size: 12px;

          .title {
            font-size: 13px;
            color: var(--text-color-primary);
          }

          .tips {
            margin-top: 4px;
          }
        }
      }

      .upload-container-btn-wrap {
        margin: 0 auto;
        margin-top: 32px;
        text-align: center;
      }

      .upload-container-btn {
        cursor: pointer;
        background: var(--bg-color-tertiary);
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        display: inline-block;
        padding: 7px 40px;
        transition: all 0.2s;

        &:hover {
          color: #fff;
          background-color: var(--themeColor);
        }
      }

      .upload-success-container {
        height: 420px;
        width: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .image-container {
          display: flex;
          align-items: center;
          overflow: auto;
          height: 420px;
          width: 400px;
          &.move {
            cursor: move;
          }

          &.flex {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .scroll-container {
            text-align: center;

            img {
              filter: drop-shadow(0px 0px 9.24444px rgba(0, 0, 0, 0.15));
              height: auto;
              width: inherit;
            }
          }
        }

      }

      .bottom-btn-container {
        padding: 10px 10px 0 10px;
        margin-bottom: 10px;
        width: 100%
        position: absolute;
        bottom: 0;
        left: 0;

        .bottom-btn-item {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          background: var(--bg-color-tertiary);
          box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
          border-radius: 24px;
          cursor: pointer;
          transition: background-color 0.2s;
          float: left;

          &.ban {
            pointer-events none
            svg {
              opacity .2
            }
          }

          &:not(:first-child) {
            margin-left: 8px;
          }

          &:hover {
            background-color: var(--themeColor);
            color: white;
          }

          &.right {
            float: right;
          }

          svg {
            height: 16px;
            width: 16px
            color var(--svg-color-gray-42-secondary)
          }
        }
      }

      .text-gray {
        color: var(--text-color-tertiary);
      }
      .text-gray-bold {
        color: var(--text-color-gray-blod)
      }
    }
</style>

<template>
    <div class="OCRModal-mask">
        <Dialog class="OCRModal-modal" :isShow="true" @close="closeModal">
            <template v-slot:title>
                <div class="title-text">
                    <iconSymbol class="title-logo" name="ai-OCR-logo" />
                    <span class="title-content">{{ $t("title") }}</span>
                    <iconSymbol
                        class="title-yiwen"
                        v-tippy="{
                            content: $t('tooltips'),
                            placement: 'right',
                            arrow: true,
                        }"
                        name="yiwen"
                    />
                    <div class="points">
                        <iconSymbol name="img-ocr-ai-points" />
                        <a :href="pointLink" target="_blank">{{ $t("points") }}: {{ pointsData.balance }}</a>
                    </div>
                </div>
            </template>
            <div class="OCRModal-container">
                <div class="OCRModal-container-item left">
                    <!-- 原生上传input，自定义按钮点击上传文件  -->
                    <input type="file" ref="uploadInput" :accept="accept" @change="beforeUpload($event.target.files[0])" style="display: none" />
                    <template v-if="!imageURL">
                        <Upload
                            ref="upload"
                            type="drag"
                            name="image"
                            :accept="accept"
                            :show-upload-list="false"
                            :on-success="onSuccess"
                            :before-upload="beforeUpload"
                            :on-progress="onProgress"
                            action=""
                        >
                            <div class="upload-container">
                                <div class="upload-container-img">
                                    <img :src="require('@/app/assets/img/ai/ai-upload.png')" alt="" />
                                </div>
                                <div class="upload-container-text">
                                    <div class="title">
                                        {{ $t("drag") }}
                                    </div>
                                    <div class="tips text-gray">
                                        {{ $t("dragTips") }}
                                    </div>
                                </div>
                            </div>
                        </Upload>
                        <div class="upload-container-btn-wrap">
                            <div class="upload-container-btn" @click="handleUploadBtnClick">
                                {{ $t("selectFile") }}
                            </div>
                        </div>
                    </template>
                    <div v-show="imageURL">
                        <div class="upload-success-container">
                            <div
                                ref="imageContainer"
                                class="image-container"
                                :class="{
                                    flex: imageWidth < previewWidth - 4,
                                    move: canMove,
                                }"
                            >
                                <div class="scroll-container" @mousedown="handleMoveImage($event)">
                                    <img ref="uploadImage" draggable="false" :src="imageURL" :style="{ width: imageWidth + 'px' }" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="bottom-btn-container">
                            <div
                                v-tippy="{
                                    content: $t('delete'),
                                    placement: 'bottom',
                                    arrow: true,
                                }"
                                class="bottom-btn-item"
                                @click="removeImage"
                            >
                                <icon-symbol name="ai-delete"></icon-symbol>
                            </div>
                            <div
                                v-tippy="{
                                    content: $t('replace'),
                                    placement: 'bottom',
                                    arrow: true,
                                }"
                                class="bottom-btn-item"
                                @click="handleUploadBtnClick"
                            >
                                <icon-symbol name="ai-change"></icon-symbol>
                            </div>
                            <div
                                v-tippy="{
                                    content: $t('fit'),
                                    placement: 'bottom',
                                    arrow: true,
                                }"
                                class="bottom-btn-item right"
                                @click="scaleFullImage"
                            >
                                <icon-symbol name="ai-full-screen"></icon-symbol>
                            </div>
                            <div
                                v-tippy="{
                                    content: $t('zoomOut'),
                                    placement: 'bottom',
                                    arrow: true,
                                }"
                                class="bottom-btn-item right"
                                :class="{ ban: imageWidth < 200 }"
                                @click="scaleDownImage"
                            >
                                <icon-symbol name="ai-scale-down"></icon-symbol>
                            </div>
                            <div
                                v-tippy="{
                                    content: $t('zoomIn'),
                                    placement: 'bottom',
                                    arrow: true,
                                }"
                                class="bottom-btn-item right"
                                :class="{ ban: imageWidth > 1920 }"
                                @click="scaleUpImage"
                            >
                                <icon-symbol name="ai-scale-up"></icon-symbol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="OCRModal-container-item right">
                    <template v-if="!textarea">
                        <div class="container-part-1">
                            <template v-if="!OCRLoading">
                                <div v-if="!OCRData" class="text-gray-bold">
                                    <template v-if="!imageURL">
                                        <p v-html="$t('waitTips')"></p>
                                    </template>
                                    <template v-if="imageURL">
                                        {{ $t("clickTips") }}
                                    </template>
                                </div>
                                <!-- 无点数占位符   -->
                                <div v-else-if="OCRData && OCRData.msg === 'no enough points'">
                                    <icon-symbol class="empty" name="ai-empty"></icon-symbol>
                                    <div class="text-gray-bold">
                                        {{ $t("no enough points") }}
                                    </div>
                                </div>
                                <!-- 未识别到字  -->
                                <div v-else-if="OCRData && OCRData.data && OCRData.data.words_result_num === 0">
                                    <icon-symbol class="empty" name="ai-empty"></icon-symbol>
                                    <div class="text-gray-bold">
                                        {{ $t("noContent") }}
                                    </div>
                                </div>
                            </template>
                            <!--  加载占位符  -->
                            <template v-if="OCRLoading">
                                <div>
                                    <div class="ORC-loading-logobox">
                                        <icon-symbol class="ORC-loading-logo" name="ai-doing-OCR"></icon-symbol>
                                        <icon-symbol class="ORC-loading-logo ocr-logo-animation" name="ai-doing-OCR-rect"></icon-symbol>
                                    </div>
                                    <div>{{ $t("doing") }}</div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-if="textarea">
                        <div class="textarea-container">
                            <Input class="text-area" type="textarea" v-model="textarea" :border="false" />
                            <!--              <div class="copy-btn" @click="handleCopy">-->
                            <!--                <icon-symbol name="ai-copy"></icon-symbol>-->
                            <!--              </div>-->
                        </div>
                    </template>
                </div>
            </div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" :class="{ 'dialog-disable': !imageURL }" @click="imageURL && startOCR()" v-show="!textarea">
                    {{ $t("start") }}
                </div>
                <div class="dialog-btn-ok" :class="{ 'dialog-disable': !textarea }" @click="textarea && insertToCanvas()" v-show="textarea">
                    {{ $t("create") }}
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Inject, Vue } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class OCRModal extends Vue {
        @Inject()
        ["showMessage"];
        tableName: string = "";
        DbName: string = "userDB";
        imageURL: string = "";
        imageWidth: number = 200;
        file: Blob = null;
        OCRLoading: boolean = false;
        accept: string = ".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PNG,.BMP";
        previewWidth = 400;
        textarea = "";
        pointsData = { balance: 0 };
        OCRData: any = null;

        // 识别一段一段的文字拼接
        get OCRDataText() {
            let str = "";
            this.OCRData.data.words_result.forEach((item) => {
                str += item.words + "\r\n";
            });
            return str;
        }
        get textList() {
            return this.OCRData.data.words_result.map((item) => item.words);
        }
        get pointLink() {
            let custom = encodeURIComponent(
                btoa(
                    JSON.stringify({
                        id: this.userInfo.user_id,
                        token: this.userInfo.token,
                    })
                )
            );
            const availableLang = ["de", "fr", "es", "pt", "it", "jp"].includes(this.lang) ? `/${this.lang}` : "no";
            let host = this.internal
                ? "https://www.edrawsoft.cn/order/recharge-page.html"
                : `https://www.edrawsoft.com${availableLang}/pricing-ai-edrawmax.html`;
            if (!this.internal && availableLang == "no") {
                host = "https://edrawmax.wondershare.com/store/pricing-ai.html";
            }
            if (!this.internal && this.lang == "en") {
                // 仅en跳转固定链接
                host = "https://www.edrawmax.com/store/effects-buy.html";
            }
            return `${host}?product=max&platform=maxonline&custom=${custom}`;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        handleUploadBtnClick() {
            // 模拟点击上传按钮
            (this.$refs.uploadInput as HTMLInputElement).click();
        }

        insertToCanvas() {
            window["_view"].createTempPage(this.textList, "text");
            this.$edMessage.success(this.$t("generatedSuccessfully"));
            // this.close()
        }

        close() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        // 获取ai点数
        async getPoints() {
            try {
                this.pointsData = await this.$edApi.getPoints(this.userInfo);
            } catch (e) {
                this.$edMessage.error(e.toString());
            }
        }
        /**
         * js压缩图片
         * @param file 图片文件对象
         * @param quality 压缩倍率 0~1
         * @constructor
         */
        compressImage(file, quality = 0.5) {
            //默认0.5倍压缩
            return new Promise((resolve, reject) => {
                console.log(file);
                //保存文件名，后边用到
                var name = file.name;
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    console.log(e);
                    var src = (e.target as any).result;
                    var img = new Image();
                    img.src = src;
                    console.dir(img);
                    img.onload = function (e) {
                        var w = img.width;
                        var h = img.height;
                        //生成canvas
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        // 创建属性节点
                        var anw = document.createAttribute("width");
                        (anw.nodeValue as any) = w;
                        var anh = document.createAttribute("height");
                        (anh.nodeValue as any) = h;
                        canvas.setAttributeNode(anw);
                        canvas.setAttributeNode(anh);

                        //铺底色 PNG转JPEG时透明区域会变黑色
                        ctx.fillStyle = "#fff";
                        ctx.fillRect(0, 0, w, h);

                        ctx.drawImage(img, 0, 0, w, h);
                        // quality值越小，所绘制出的图像越模糊
                        var base64 = canvas.toDataURL("image/jpeg", quality); //图片格式jpeg或webp可以选0-1质量区间
                        // 返回base64转blob的值
                        console.log(
                            "\u539F\u56FE" + (src.length / 1024).toFixed(2) + "kb",
                            "\u65B0\u56FE" + (base64.length / 1024).toFixed(2) + "kb"
                        );
                        //去掉url的头，并转换为byte
                        var bytes = window.atob(base64.split(",")[1]);
                        //处理异常,将ascii码小于0的转换为大于0
                        var ab = new ArrayBuffer(bytes.length);
                        var ia = new Uint8Array(ab);
                        for (var i = 0; i < bytes.length; i++) {
                            ia[i] = bytes.charCodeAt(i);
                        }
                        //通过Blob生成新图片文件对象
                        file = new Blob([ab], { type: "image/jpeg" });
                        //这里需要重新设置文件名
                        file.name = name;
                        resolve(file);
                        return file;
                    };
                    img.onerror = function (e) {
                        console.error(e);
                        reject(e);
                    };
                };
                reader.onerror = function (e) {
                    console.error(e);
                };
            });
        }
        async startOCR() {
            this.textarea = "";
            this.OCRLoading = true;
            const formData = new FormData();
            formData.append("image", this.file);
            formData.append("platform", "web");
            try {
                const res = await this.$edApi.OCRIdentify({
                    formData,
                    user_id: this.userInfo.user_id,
                    token: this.userInfo.token,
                });
                console.log(res);
                this.OCRLoading = false;
                this.OCRData = res;
                this.textarea = this.OCRDataText; // 初始化输入框文本，用户可输入修改文本框

                this.sensors.track("ClickStartExtraction", {
                    Catalogues: "AI",
                    result: "success",
                });
            } catch (e) {
                this.OCRLoading = false;
                this.$edMessage.error(this.$t("ocr service error"));

                this.sensors.track("ClickStartExtraction", {
                    Catalogues: "AI",
                    result: "failure",
                });
            } finally {
                await this.getPoints();
            }
        }

        scaleFullImage() {
            this.imageWidth = 394;
            this.setCanMove();
        }

        scaleUpImage() {
            if (this.imageWidth > 1920) return;
            this.imageWidth *= 1.2;
            this.setCanMove();
        }

        scaleDownImage() {
            if (this.imageWidth < 200) return;
            this.imageWidth /= 1.2;
            this.setCanMove();
        }

        removeImage() {
            (this.$refs.uploadInput as HTMLInputElement).value = ""; // 清空输入框选择的文件
            this.imageURL = "";
            this.file = null;
            this.textarea = "";
            this.OCRData = null;
        }

        onSuccess(response, file, fileList) {
            console.log(response, file, fileList);
        }

        async beforeUpload(file) {
            this.removeImage();
            let fileName = file.name;
            let pos = fileName.lastIndexOf("."),
                suffix = fileName.substr(pos),
                typeList = this.accept.split(",");
            console.log(suffix, typeList);
            if (!typeList.includes(suffix)) {
                this.$edMessage.error(this.$t("invalid file"));
                return;
            }
            const limit = 5;
            if (file.size > 1024 * 1024 * limit) {
                // file=await this.compressImage(file,0.8)// 图片大于5M进行压缩
                return this.$Message.error(this.$t("limitTips"));
            }
            this.imageURL = URL.createObjectURL(file);
            this.file = file;
            this.scaleFullImage();
            return false;
        }

        onProgress(event, file, fileList) {
            console.log("event, file, fileList");
        }

        canMove = false;
        setCanMove() {
            this.$nextTick(() => {
                const dom = this.$refs.imageContainer as HTMLElement;
                if (dom && (dom.scrollWidth != dom.clientWidth || dom.scrollHeight !== dom.clientHeight)) {
                    this.canMove = true;
                } else {
                    this.canMove = false;
                }
            });
        }
        handleMoveImage(e) {
            if (!this.canMove) return;
            const dom = this.$refs.imageContainer as HTMLElement;
            const scrollLeft = dom.scrollLeft,
                scrollTop = dom.scrollTop,
                right = dom.scrollWidth - dom.clientWidth,
                bottom = dom.scrollHeight - dom.clientHeight;
            let startX = e.pageX,
                startY = e.pageY;
            document.onmousemove = (ev) => {
                let moveX = ev.pageX,
                    moveY = ev.pageY;
                let changeX = scrollLeft - (moveX - startX);
                let changeY = scrollTop - (moveY - startY);
                changeX = changeX < 0 ? 0 : changeX > right ? right : changeX;
                changeY = changeY < 0 ? 0 : changeY > bottom ? bottom : changeY;
                dom.scrollLeft = changeX;
                dom.scrollTop = changeY;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        refreshAiPoint() {
            console.log("ocr visible event");
            this.getPoints();
        }
        extractTextOnShape(file) {
            this.file = file;
            this.imageURL = URL.createObjectURL(file);
            this.startOCR();
        }

        created() {
            this.$bus.$on("appVisible", this.refreshAiPoint);
            this.$bus.$on("extractTextOnShape", this.extractTextOnShape);
            this.getPoints();
        }
        beforeDestroy() {
            this.$bus.$off("appVisible", this.refreshAiPoint);
            this.$bus.$off("extractTextOnShape", this.extractTextOnShape);
        }
    }
</script>
<i18n>
{
  "zh": {
    "generatedSuccessfully":"生成成功",
    "noContent": "没有检测到文字内容，请重新上传",
    "no enough points": "AI点数不足，无法执行指令，请先充值后唤醒小助手。",
    "points": "剩余AI点数",
    "limitTips": "最大支持上传5M的文件，请重新上传",
    "network error": "网络异常",
    "invalid file": "文件类型不合法",
    "ocr service error": "OCR服务异常",
    "title": "OCR图片文字提取",
    "tooltips": "通过OCR识别图片，可以直接提取并复制文字",
    "selectFile": "选择文件",
    "drag": "拖拽图片到这里，或点击选择文件",
    "dragTips": "支持 jpg/jpeg/png/bmp 格式",
    "waitTips": "等您好久了，<br/>快去左侧选择图片吧~",
    "clickTips": "点击下方按钮开始提取",
    "start": "开始提取",
    "delete": "删除文件",
    "replace": "替换文件",
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "fit": "适配窗口",
    "doing": "文件提取中",
    "create": "生成到画布",
    "copySuccess": "复制成功"
  },
  "en": {
    "generatedSuccessfully":"Generated successfully",
    "noContent": "No text content detected, please upload again",
    "points": "Remaining AI points",
    "no enough points": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "limitTips": "The maximum support for uploading files is 5M, please re-upload",
    "network error": "network error",
    "invalid file": "invalid file",
    "ocr service error": "ocr service error",
    "title": "OCR Image Text Extraction",
    "tooltips": "Extract text and characters from images through OCR. You can directly extract and copy text.",
    "selectFile": "Select a document",
    "drag": "Drag the image here or Click to upload a document",
    "dragTips": "Support JPG/JPEG/PNG/BMP format",
    "waitTips": "Waiting for you for a long time, go to the left to select the picture~",
    "clickTips": "Click the button below to start extraction",
    "start": "Start",
    "delete": "delete a file",
    "replace": "replace file",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "fit": "Fit in the window",
    "doing": "File extraction",
    "create": "Create",
    "copySuccess": "Copy Successfully"
  },
  "fr": {
    "generatedSuccessfully":"Génération effectuée",
    "noContent": "Aucun contenu texte détecté.Téléchargez à nouveau.",
    "title": "Extraction de texte d'image via OCR",
    "no enough points": "Points IA insuffisants, impossible d'exécuter les instructions. Veuillez d'abord recharger vos points, puis réactiver l'assistant.",
    "points": "Points IA restants",
    "limitTips": "La prise en charge maximale pour le téléchargement de fichiers est de 5 Mo, veuillez télécharger à nouveau.",
    "copySuccess": "copié avec succès"
  },
  "de": {
    "generatedSuccessfully":"Erfolgreich generiert",
    "noContent": "Kein Textinhalt erkannt, bitte erneut hochladen",
    "title": "OCR Bild-Text-Extraktion",
    "no enough points": "Nicht genügend AI-Punkte, Anweisung kann nicht ausführt werden. Bitte laden Sie erst Punkte auf und aktivieren Sie dann den Assistenten",
    "points": "Verbleibende AI-Punkte",
    "limitTips": "Es können maximal 5 MB an Dateien hochgeladen werden. Bitte laden Sie sie erneut hoch",
    "copySuccess": "Kopieren erfolgreich"
  },
  "jp": {
    "generatedSuccessfully":"生成が完了しました",
    "noContent": "テキストコンテンツが検出されませんでした。もう一度アップロードしてください",
    "title": "OCR画像テキスト抽出",
    "no enough points": "AIポイントが不足しているため、命令を実行できません。再チャージしてからアシスタントを起動してください",
    "points": "AIポイント残り",
    "limitTips": "アップロードできる最大ファイルサイズは5MBです。アップロードし直してください",
    "copySuccess": "コピー成功"
  },
  "es": {
    "generatedSuccessfully":"Generado correctamente",
    "noContent": "No se ha detectado contenido de texto. Vuelve a cargarlo",
    "title": "Extracción de texto de imágenes con OCR",
    "no enough points": "Puntos de AI insuficientes: no se pueden ejecutar las instrucciones. Recarga y activa el asistente",
    "points": "Puntos de AI restantes",
    "limitTips": "El tamaño máximo para la carga de archivos es de 5 MB. Vuelve a cargar",
    "copySuccess": "Copiado con éxito"
  },
  "pt": {
    "generatedSuccessfully":"Gerado com sucesso",
    "noContent": "Nenhum conteúdo de texto detectado. Faça o upload novamente",
    "title": "Extração de texto de imagem por OCR",
    "no enough points": "Pontos de IA insuficientes. Não é possível executar instruções, recarregue primeiro e, em seguida, ative o assistente",
    "points": "Pontos de IA restantes",
    "limitTips": "O suporte máximo para carregar arquivos é 5 MB. Faça o upload novamente",
    "copySuccess": "Copiado com Sucesso"
  },
  "id": {
    "generatedSuccessfully":"Berhasil dihasilkan",
    "noContent": "Konten teks tidak terdeteksi. Unggah lagi",
    "title": "Ekstraksi Teks Gambar OCR",
    "no enough points": "Poin AI tidak cukup sehingga gagal menjalankan instruksi. Isi ulang terlebih dahulu, lalu aktifkan asisten",
    "points": "Sisa poin AI",
    "limitTips": "Ukuran file maksimum yang dapat diunggah adalah 5 MB. Unggah ulang",
    "copySuccess": "Copia Eseguita con Successo"
  },
  "it": {
    "generatedSuccessfully":"Generazione completata correttamenten",
    "noContent": "Non è stato rilevato alcun contenuto. Carica nuovamente",
    "title": "Estrazione del testo da immagine OCR",
    "no enough points": "Punti AI insufficienti. Non è possibile eseguire le istruzioni. Effettua prima una ricarica e riattiva l'assistente",
    "points": "Punti AI rimanenti",
    "limitTips": "Sono supportati fino a un massimo di 5M. Ricarica",
    "copySuccess": "Copia Eseguita con Successo"
  },
  "tw": {
    "generatedSuccessfully":"已成功產生",
    "noContent": "未偵測到文字內容，請再次上傳",
    "title": "OCR 影像文字擷取",
    "no enough points": "AI 點數不足，無法執行指令，請先補充點數再喚醒助理",
    "points": "剩餘 AI 點數",
    "limitTips": "上傳的檔案大小上限為 5MB，請重新上傳",
    "copySuccess": "複製成功"
  },
  "kr": {
    "generatedSuccessfully":"성공적으로 생성되었습니다.",
    "noContent": "텍스트 콘텐츠가 없습니다. 다시 업로드하세요.",
    "title": "OCR 이미지 텍스트 추출",
    "no enough points": "AI 포인트가 충분하지 않아 지침을 실행할 수 없습니다. 먼저 재충전한 후에 Assistant를 활성화하세요.",
    "points": "잔여 AI 포인트",
    "limitTips": "파일 업로드 최대 지원 분량은 5MB입니다. 다시 업로드하세요.",
    "copySuccess": "복사 성공"
  }
}
</i18n>
